import { t } from '@transifex/native';

const manageConstants = Object.freeze({
  campaigns: {
    noData: 'There are no Campaigns created yet',
    noSearchData: "Sorry, we couldn't find any campaigns",
    campaignsTableHeaders: [
      { title: t('Status') },
      { title: t('Campaign name') },
      { title: t('Delivery') },
      { title: t('Start Date') },
      { title: t('End Date') },
      { title: t('Total Budget') },
      { title: t('Amount Spent') },
      { title: t('Accepted') },
      { title: t('Completed') },
      { title: t('Clicks') },
      { title: t('CTR %') },
      { title: t('Conversion %') },
      { title: t('Frequency') },
      { title: t('Archive') },
    ],
    archivedCampaignsTableHeaders: [
      { title: t('Status') },
      { title: t('Campaign name') },
      { title: t('Delivery') },
      { title: t('Start Date') },
      { title: t('End Date') },
      { title: t('Total Budget') },
      { title: t('Amount Spent') },
      { title: t('Accepted') },
      { title: t('Completed') },
      { title: t('Clicks') },
      { title: t('CTR %') },
      { title: t('Converion %') },
      { title: t('Frequency') },
    ],
  },
  adSets: {
    noData: 'There are no Ad Sets created yet',
    noSearchData: "Sorry, we couldn't find any Ad sets",
    adSetsTableHeaders: [
      { title: t('Status') },
      { title: t('Ad Set Name') },
      { title: t('Delivery') },
      { title: t('Start Date') },
      { title: t('End Date') },
      { title: t('Budget') },
      { title: t('Amount Spent') },
      { title: t('Daily Budget') },
      { title: t('Accepted') },
      { title: t('Completed') },
      { title: t('Clicks') },
      { title: t('CTR %') },
      { title: t('Frequency') },
    ],
  },
  ads: {
    noData: 'There are no Ads created yet',
    noSearchData: "Sorry, we couldn't find any Ads",
    adsTableHeaders: [
      { title: t('Status') },
      { title: t('Ad name') },
      { title: t('Delivery') },
      { title: t('Creative') },
      { title: t('Questions') },
      { title: t('CTA Tile') },
      { title: t('CTA Link') },
      { title: t('Accepted') },
      { title: t('Completed') },
      { title: t('Clicks') },
      { title: t('CTR %') },
      { title: t('Conversion %') },
      { title: t('Frequency') },
    ],
  },
  itemsPerPage: [
    { name: '20 results', label: '20 results per page', value: 20 },
    { name: '30 results', label: '30 results per page', value: 30 },
    { name: '40 results', label: '40 results per page', value: 40 },
  ],
  statusItems: [
    {
      label: 'Active / Inactive',
      value: 'activeInactive',
    },
    {
      label: 'Archived',
      value: 'archived',
    },
  ],
});

export default manageConstants;
